var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSummaryDate = function SvgSummaryDate(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 61,
    viewBox: "0 0 48 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "36bzt74bca",
    d: "M0 0.954L47.635 0.954 47.635 4.799 0 4.799z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9oje63x9vc",
    d: "M0 60.88L47.635 60.88 47.635 0 0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-306 -432) translate(306 432)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 56.08)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tmr2klmtvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#36bzt74bca"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M0 4.366c0 .239.16.433.356.433H47.28c.196 0 .356-.194.356-.433V.954H0v3.412z",
    mask: "url(#tmr2klmtvb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5743AF",
    d: "M44.3 4.492H3.335C1.494 4.492 0 5.985 0 7.825v8.442h47.634V7.825c0-1.84-1.492-3.333-3.333-3.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C50",
    d: "M38.95 6.181v2.426c0 .035-.008.07-.01.106.113.108.216.226.306.355.024-.121.039-.245.039-.372V4.542h-.335V6.18zM35.67 6.977V4.54h-.335v4.155c0 .127.013.251.037.372.092-.13.195-.247.309-.355-.003-.036-.011-.07-.011-.107v-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E71CB",
    d: "M37.31 8.14c-1.412 0-2.557 1.144-2.557 2.555 0 1.413 1.145 2.556 2.556 2.556 1.413 0 2.558-1.143 2.558-2.556 0-1.411-1.145-2.556-2.558-2.556M23.818 8.14c-1.412 0-2.556 1.144-2.556 2.555 0 1.413 1.144 2.556 2.556 2.556 1.412 0 2.556-1.143 2.556-2.556 0-1.411-1.144-2.556-2.556-2.556M10.55 8.14c-1.41 0-2.556 1.144-2.556 2.555 0 1.413 1.145 2.556 2.556 2.556s2.556-1.143 2.556-2.556c0-1.411-1.145-2.556-2.556-2.556"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "jcdjxrwvkd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9oje63x9vc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A9A9",
    d: "M0 21.678L47.635 21.678 47.635 17.088 0 17.088z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311D88",
    d: "M0 21.333L47.635 21.333 47.635 16.266 0 16.266z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#261768",
    d: "M37.31 8.058c-1.31 0-2.372 1.062-2.372 2.372 0 1.31 1.062 2.371 2.371 2.371 1.31 0 2.373-1.062 2.373-2.371 0-1.31-1.062-2.372-2.373-2.372",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233246",
    d: "M35.67 9.769c0 .9.738 1.639 1.64 1.639.902 0 1.64-.738 1.64-1.64V7.344h-3.28V9.77z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37465A",
    d: "M37.31 0c-.902 0-1.64.738-1.64 1.64v2.178h3.28V1.64c0-.902-.738-1.64-1.64-1.64",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C50",
    d: "M35.67 8.139L38.95 8.139 38.95 2.998 35.67 2.998z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#261768",
    d: "M23.818 8.058c-1.31 0-2.373 1.062-2.373 2.372 0 1.31 1.062 2.371 2.373 2.371 1.31 0 2.372-1.062 2.372-2.371 0-1.31-1.062-2.372-2.372-2.372",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233246",
    d: "M22.178 9.769c0 .9.738 1.639 1.64 1.639.901 0 1.64-.738 1.64-1.64V7.344h-3.28V9.77z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37465A",
    d: "M23.818 0c-.902 0-1.64.738-1.64 1.64v2.178h3.279V1.64c0-.902-.738-1.64-1.64-1.64",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C50",
    d: "M22.177 8.139L25.457 8.139 25.457 2.998 22.177 2.998z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C50",
    d: "M25.457 6.181v2.426c0 .035-.008.07-.01.106.113.108.218.226.308.355.024-.121.037-.245.037-.372V4.542h-.335V6.18zM22.178 6.977V4.54h-.335v4.155c0 .127.014.251.037.372.091-.13.194-.247.308-.355-.002-.036-.01-.07-.01-.107v-1.63z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#261768",
    d: "M10.55 8.058c-1.309 0-2.372 1.062-2.372 2.372 0 1.31 1.063 2.371 2.372 2.371 1.31 0 2.373-1.062 2.373-2.371 0-1.31-1.064-2.372-2.373-2.372",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233246",
    d: "M8.91 9.769c0 .9.738 1.639 1.64 1.639.902 0 1.64-.738 1.64-1.64V7.344H8.91V9.77z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37465A",
    d: "M10.55 0c-.9 0-1.64.738-1.64 1.64v2.178h3.28V1.64c0-.902-.739-1.64-1.64-1.64",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C50",
    d: "M8.91 8.139L12.19 8.139 12.19 2.998 8.91 2.998z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C50",
    d: "M12.19 6.181v2.426c0 .035-.008.07-.01.106.114.108.217.226.308.355.023-.121.037-.245.037-.372V4.542h-.335V6.18zM8.91 6.977V4.54h-.335v4.155c0 .127.015.251.038.372.09-.13.194-.247.308-.355-.002-.036-.01-.07-.01-.107v-1.63z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M47.635 57.656L14.028 57.656 14.028 43.629 0 43.629 0 21.333 47.635 21.333z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M0 57.656L0 43.629 14.027 57.656z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.027 57.656L0 43.629 14.027 43.629z",
    mask: "url(#jcdjxrwvkd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M14.027 57.656L14.027 43.629 28.054 57.656z",
    mask: "url(#jcdjxrwvkd)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSummaryDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/summary_date.d1f0de02.svg";
export { ForwardRef as ReactComponent };